export default function ChatgptFewShot() {
  return <h2>Chatgpt Few Shot</h2>;
}
